// Real data from GMT Drywall & Painting

export const mockReviews = [
  {
    id: 1,
    name: "Madelon D.",
    rating: 5,
    date: "3 months ago",
    text: "I highly recommend GMT! This crew are communicative, positive, and excellent quality drywaller's. They always showed up on time, were respectful of our home, super clean given the nature of the job. At the end of the job, they left our home cleaner than it was when they started!",
    avatar: "MD"
  },
  {
    id: 2,
    name: "Allison R.",
    rating: 5,
    date: "4 months ago",
    text: "They were very collaborative in talking through my options and kept me informed every step of the way. The finished work looks better than I could imagine. If I need drywall work in the future, they'll have a return customer! Thanks GMT!!",
    avatar: "AR"
  },
  {
    id: 3,
    name: "Jordan W.",
    rating: 5,
    date: "5 months ago",
    text: "GMT did an awesome job! Their price was competitive and fair. GMT communicated plans in advance and were prompt each day they showed up. They kept dust to a minimum. They explained what they were planning to do in more detail than others who quoted the job, and were overall extremely professional.",
    avatar: "JW"
  },
  {
    id: 4,
    name: "Mike S.",
    rating: 5,
    date: "2 months ago",
    text: "Mike and Geno were absolutely phenomenal. 5 stars plus punctual, clean and responsive. Excellent work for hanging drywall, mudding, taping, sanding and putting a skim coat on a wall. Highly recommend!",
    avatar: "MS"
  },
  {
    id: 5,
    name: "Sarah L.",
    rating: 5,
    date: "6 months ago",
    text: "Fast, good quality work on new drywall in my garage. Very satisfied with the results and professionalism. Great communication throughout the project.",
    avatar: "SL"
  },
  {
    id: 6,
    name: "Robert K.",
    rating: 5,
    date: "7 months ago",
    text: "Excellent job!! On time every day and finished early. They even fixed some sub par work from a previous contractor. Highly recommend GMT Drywall! Worth every penny.",
    avatar: "RK"
  },
  {
    id: 7,
    name: "Jennifer M.",
    rating: 5,
    date: "8 months ago",
    text: "Communication was excellent! Started exactly when they said and finished on time. Great job, would definitely recommend to others. Very professional team.",
    avatar: "JM"
  },
  {
    id: 8,
    name: "David P.",
    rating: 5,
    date: "9 months ago",
    text: "Very good experience; fast, did what they said they would do. The install looks good and they were easy to work with throughout the project. Clean work site every day.",
    avatar: "DP"
  }
];

export const services = [
  {
    id: 1,
    title: "Drywall Installation",
    description: "Professional drywall hanging and installation for new construction and renovation projects.",
    features: [
      "New drywall installation",
      "Residential & commercial",
      "Ceiling installation",
      "Room additions"
    ]
  },
  {
    id: 2,
    title: "Drywall Finishing",
    description: "Expert taping, mudding, sanding, and skim coating for flawless walls and ceilings.",
    features: [
      "Taping & mudding",
      "Sanding & skim coating",
      "Level 5 finishing",
      "Texture matching"
    ]
  },
  {
    id: 3,
    title: "Texture Removal & Application",
    description: "Specialized texture removal and custom texture application services.",
    features: [
      "Popcorn ceiling removal",
      "Smooth finish application",
      "Custom texture styles",
      "Modern finish options"
    ]
  },
  {
    id: 4,
    title: "Drywall Repairs",
    description: "Quality repair services for holes, cracks, water damage, and structural issues.",
    features: [
      "Hole and crack repair",
      "Water damage restoration",
      "Patch work & blending",
      "Fixing sub-par work"
    ]
  },
  {
    id: 5,
    title: "Interior Painting",
    description: "High-quality interior painting for residential and commercial spaces.",
    features: [
      "Walls and ceilings",
      "Trim and doors",
      "Multi-room projects",
      "Clean, professional finish"
    ]
  },
  {
    id: 6,
    title: "Exterior Painting",
    description: "Durable exterior painting solutions that protect and beautify your property.",
    features: [
      "House painting",
      "Weather-resistant coatings",
      "Surface preparation",
      "Long-lasting finishes"
    ]
  }
];

export const serviceTypes = [
  { value: "drywall-installation", label: "Drywall Installation" },
  { value: "drywall-finishing", label: "Drywall Finishing" },
  { value: "texture", label: "Texture Removal/Application" },
  { value: "drywall-repair", label: "Drywall Repairs" },
  { value: "interior-painting", label: "Interior Painting" },
  { value: "exterior-painting", label: "Exterior Painting" },
  { value: "multiple", label: "Multiple Services" },
  { value: "other", label: "Other / Not Sure" }
];

export const projectGallery = [
  {
    id: 1,
    url: "https://static.wixstatic.com/media/a79910_38be1ae1a44342a9a078b47c2d3c842f~mv2.jpeg",
    alt: "GMT Drywall Project 1"
  },
  {
    id: 2,
    url: "https://static.wixstatic.com/media/a79910_f6493ecb2b2342328cf5e2fcf23d3aef~mv2.jpeg",
    alt: "GMT Drywall Project 2"
  },
  {
    id: 3,
    url: "https://static.wixstatic.com/media/a79910_a4859ec1409a4cecbfb1c88c93956bf4~mv2.jpeg",
    alt: "GMT Drywall Project 3"
  },
  {
    id: 4,
    url: "https://static.wixstatic.com/media/nsplsh_a154bfd8eed54cae80001c77eb8158f8~mv2.jpg",
    alt: "GMT Drywall Project 4"
  }
];
